import script from "./GalleryComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./GalleryComponent.vue?vue&type=script&setup=true&lang=js"

import "./GalleryComponent.vue?vue&type=style&index=0&id=309b5e84&lang=css"

const __exports__ = script;

export default __exports__